let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hmn6")).then(() => parcelRequire('3XbAb'));